import { type ApolloError } from 'apollo-client'
import {
  useGetSignedUrlQuery,
  type GetSignedUrlQueryVariables,
  type GetSignedUrlQuery,
} from 'domains/products/api'

export const useGetSignedUrl = (
  variables: GetSignedUrlQueryVariables,
  skip?: boolean,
  pollInterval?: number,
  onCompleted?: (data: GetSignedUrlQuery) => void,
  onError?: (error: ApolloError) => void
) => {
  const {
    data,
    error: apiError,
    loading: apiLoading,
    refetch: apiRefetch,
  } = useGetSignedUrlQuery({
    variables,
    skip,
    pollInterval,
    onCompleted,
    onError,
    notifyOnNetworkStatusChange: true,
  })

  return {
    apiResponse: data?.catalogSearchDownloadSignedUrl?.signedUrl,
    apiError,
    apiLoading,
    apiRefetch,
  }
}
